/**
 * Utilities for filtering published boards and academic years.
 * Uses case-insensitive matching for status (published, Published, PUBLISHED, etc.)
 */

/**
 * Check if an item (board or academic year) is published.
 * Case-insensitive match for status_id and status_value (published, Published, PUBLISHED, etc.).
 * When status is missing, include the item (assume from pre-filtered API).
 * @param {Object} item - Board or academic year object
 * @returns {boolean}
 */
export const isPublished = (item) => {
  if (!item) return false;
  const sid = String(item?.status_id ?? item?.statusId ?? '').trim().toLowerCase();
  const val = String(item?.status_value ?? item?.statusValue ?? '').trim().toLowerCase();
  if (!sid && !val) return true; // No status = assume published (from pre-filtered API)
  return sid === 'published' || val === 'published';
};

/**
 * Filter array to only published items (case-insensitive).
 * @param {Array} items - Boards or academic years
 * @returns {Array}
 */
export const filterPublished = (items) => {
  if (!Array.isArray(items)) return [];
  return items.filter(isPublished);
};
